export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">手机App下载</h2>
            <p className="text-sm md:text-base text-background-300 leading-relaxed max-w-lg mb-6">
              下载黑料视频官方手机App，随时随地观看最新黑料视频。支持iOS和Android双平台，安装简单，界面清爽，推送及时。App内置黑料视频在线观看与黑料视频下载功能，让你不错过任何精彩内容。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a href="#" className="inline-flex items-center gap-2 bg-background-50 hover:bg-background-100 text-foreground-900 font-medium px-5 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a href="#" className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-5 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-4">
              <span className="flex items-center gap-1 text-xs text-background-400">
                <i className="ri-shield-check-line text-accent-400"></i> 安全无毒
              </span>
              <span className="flex items-center gap-1 text-xs text-background-400">
                <i className="ri-download-2-line text-primary-400"></i> 下载量 800万+
              </span>
              <span className="flex items-center gap-1 text-xs text-background-400">
                <i className="ri-star-fill text-accent-400"></i> 评分 4.9
              </span>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20dark%20theme%20video%20streaming%20app%20interface%20with%20amber%20and%20crimson%20accent%20colors%2C%20entertainment%20news%20feed%20layout%2C%20video%20thumbnails%20grid%2C%20clean%20UI%20design%2C%20premium%20mobile%20app%20aesthetic%2C%20floating%20phone%20on%20dark%20background%2C%20professional%20product%20photography&width=500&height=700&seq=app-phone-mock-2026&orientation=portrait"
                alt="黑料视频手机App界面展示"
                className="relative w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}